/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { BulkSelectionMode } from './bulkSelectionMode';

/**
 * Describes how a bulk action should resolve to a concrete ID set.
 *
 * * ``include`` — explicit ID list.
 * * ``all`` — every row in the source, optionally minus ``exclude_ids``.
 * * ``range`` — a slice of the source defined by ``count`` and ``skip``,
 *   optionally minus ``exclude_ids``. The slice respects the source's
 *   natural order (snapshot position for searches, score ranking for
 *   arbitrator sessions).
 */
export interface BulkSelection {
  mode: BulkSelectionMode;
  include_ids?: string[] | null;
  exclude_ids?: string[] | null;
  count?: number | null;
  skip?: number | null;
}
